<template>
  <div
    class="playerInteraction"
  >
    <el-col :span="14" style="width:100%">
            <div class="grid-content bg-purple newsNav">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="隐私条款" name="first">
                  <div class="privacyText"  style="height:450px;overflow-y:auto">{{privacyData}}</div>
                </el-tab-pane>
                
                <el-tab-pane label="用户协议" name="second">
                  <div class="privacyText"  style="height:450px;overflow-y:auto">{{userData}}</div>
                </el-tab-pane>
              </el-tabs>
            </div>
    </el-col>


    <router-view />
  </div>
</template>

<script>
import privacy from '../api/privacy'
export default {
  data() {
    return {
      activeName: "first",
      privacyData:'',
      userData:''
    };
  },

  created() {
    this.privacyData=privacy.privacyAgreement.privacy
    this.userData=privacy.privacyAgreement.userAgreement

  },

  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },

  }
};
</script>

<style scoped>
.playerInteraction {
  background: #ffffe6;
  border: 2px solid #89c33f;
  margin: 5% 0;
  padding: 5%;
  color: #603813;
  font-size: 10px;
  height: 500px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* font-weight: bold; */
}
.newsNav {
  width: 100%;
}

.privacyText {
  font-size: 10px;
  white-space: pre-wrap;
  text-align: left;
}

.el-tabs__active-bar {
  display: none;
}
.el-tabs__nav-wrap::after {
  display: none;
}
.el-col-14 {
  width: 100%;
}
.left {
  display: flex;
  margin: 0;
}
.el-pagination button:disabled {
  background-color: #ffffe6;
}
.el-pager li {
  background-color: #ffffe6;
}
.el-pagination .btn-next {
  background-color: #ffffe6;
}
/* @media screen and (max-width: 700px) {
.el-col-14 {
    width: 150%;
}
} */
</style>


// WEBPACK FOOTER //
// src/components/playerInteraction.vue